import React from 'react';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  lowResSrc?: string;
  className?: string;
  alt?: string;
  isLazy?: boolean;
}

const Image: React.FC<ImageProps> = ({
  src,
  lowResSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
  className = '',
  alt = '',
  isLazy = true,
  ...otherProps
}) => {
  return (
    <div
      className={[
        'mz-image',
        isLazy ? 'lazy' : '',
        className
      ].join(' ')}
    >
      <img
        src={isLazy ? lowResSrc : src}
        data-src={isLazy ? src : undefined}
        alt={alt}
        {...otherProps}
      />
    </div>
  );
};

export default Image;
